import {isNull} from 'underscore';
import {SubjectModel} from '../../../types/subject';

export function getListValue(value: SubjectModel['id'] | null) {
	return isNull(value) ? '' : String(value);
}
